import { apiClient } from '@/lib/api/client';
export const superadminApi = {
    // Dashboard
    async getDashboard() {
        const { data } = await apiClient.get('/api/v1/superadmin/dashboard');
        return data;
    },
    // Tenant CRUD
    async listTenants(opts) {
        const { data } = await apiClient.get('/api/v1/superadmin/tenants', { params: opts });
        return data;
    },
    async createTenant(dto) {
        const { data } = await apiClient.post('/api/v1/superadmin/tenants', dto);
        return data;
    },
    async getTenant(id) {
        const { data } = await apiClient.get(`/api/v1/superadmin/tenants/${id}`);
        return data;
    },
    async updateTenant(id, dto) {
        const { data } = await apiClient.patch(`/api/v1/superadmin/tenants/${id}`, dto);
        return data;
    },
    async suspendTenant(id, reason) {
        const { data } = await apiClient.patch(`/api/v1/superadmin/tenants/${id}/suspend`, { reason });
        return data;
    },
    async reactivateTenant(id) {
        const { data } = await apiClient.patch(`/api/v1/superadmin/tenants/${id}/reactivate`);
        return data;
    },
    async deleteTenant(id) {
        await apiClient.delete(`/api/v1/superadmin/tenants/${id}`);
    },
    // Reportes
    async reportUsers() {
        const { data } = await apiClient.get('/api/v1/superadmin/reports/users');
        return data;
    },
    async reportGroups() {
        const { data } = await apiClient.get('/api/v1/superadmin/reports/groups');
        return data;
    },
    async reportPassengers() {
        const { data } = await apiClient.get('/api/v1/superadmin/reports/passengers');
        return data;
    },
    async reportServices() {
        const { data } = await apiClient.get('/api/v1/superadmin/reports/services');
        return data;
    },
    async reportTourscan() {
        const { data } = await apiClient.get('/api/v1/superadmin/reports/tourscan');
        return data;
    },
    async reportRevenue() {
        const { data } = await apiClient.get('/api/v1/superadmin/reports/revenue');
        return data;
    },
    async reportCapacity() {
        const { data } = await apiClient.get('/api/v1/superadmin/reports/capacity');
        return data;
    },
    // Rankings
    async getRankings(metric, period = 'month') {
        const { data } = await apiClient.get('/api/v1/superadmin/rankings', { params: { metric, period } });
        return data;
    },
};
//# sourceMappingURL=superadmin.js.map